var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("drawer", {
        ref: "filterDrawer",
        scopedSlots: _vm._u([
          {
            key: "defult",
            fn: function () {
              return [
                _c("sel-plat", {
                  attrs: { listQuery: _vm.listQuery },
                  on: {
                    change: function ($event) {
                      return _vm.toQuery()
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "设备类型:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.key_tag,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "key_tag", $$v)
                          },
                          expression: "listQuery.key_tag",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "-1" },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.deviceNameObj, function (item, index) {
                          return [
                            _c("el-option", {
                              attrs: { label: index, value: "" + item + "" },
                            }),
                            _vm._v(" "),
                            item == 1
                              ? _c("el-option", {
                                  attrs: { label: "蓝牙线", value: "1b" },
                                })
                              : _vm._e(),
                          ]
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "绑定设备:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.notnull_device_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "notnull_device_id", $$v)
                          },
                          expression: "listQuery.notnull_device_id",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "-1" },
                        }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "是", value: "1" } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "否", value: "0" } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-sm-and-down",
                    attrs: { label: "是否分配:" },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "status", $$v)
                          },
                          expression: "listQuery.status",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "-1" },
                        }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "是", value: "1" } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "否", value: "0" } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-md-and-down",
                    attrs: { label: "二维码号:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.key_code_sn,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "key_code_sn", $$v)
                        },
                        expression: "form.key_code_sn",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-lg-and-down",
                    attrs: { label: "设备SN:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.key_device_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "key_device_id", $$v)
                        },
                        expression: "form.key_device_id",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.toQuery(1)
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: _vm.selSnArr.length == 0,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.setEquip()
                          },
                        },
                      },
                      [_vm._v("分配")]
                    ),
                    _vm._v(" "),
                    _vm.selSnUrl.length > 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.downloadImg()
                              },
                            },
                          },
                          [_vm._v("下载")]
                        )
                      : _c(
                          "el-button",
                          {
                            attrs: { type: "primary", plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.outTable()
                              },
                            },
                          },
                          [
                            _vm._v("导出"),
                            _c("i", {
                              staticClass: "el-icon-male el-icon--right",
                            }),
                          ]
                        ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "more",
            fn: function () {
              return [
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-md-and-up",
                    attrs: { label: "是否分配:" },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "status", $$v)
                          },
                          expression: "listQuery.status",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "-1" },
                        }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "是", value: "1" } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "否", value: "0" } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-lg-and-up",
                    attrs: { label: "二维码号:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.key_code_sn,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "key_code_sn", $$v)
                        },
                        expression: "form.key_code_sn",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-xg-and-up",
                    attrs: { label: "设备SN:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.key_device_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "key_device_id", $$v)
                        },
                        expression: "form.key_device_id",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-form-item", { attrs: { label: "时间筛选:" } }, [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "开始",
                          "value-format": "timestamp",
                          "picker-options": _vm.beginOptions,
                        },
                        model: {
                          value: _vm.form.startTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "startTime", $$v)
                          },
                          expression: "form.startTime",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-5 mr-5" }, [_vm._v("-")]),
                      _vm._v(" "),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "结束",
                          "value-format": "timestamp",
                          "picker-options": _vm.endOptions,
                        },
                        model: {
                          value: _vm.form.endTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "endTime", $$v)
                          },
                          expression: "form.endTime",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "p-10" }, [
        _c(
          "div",
          { staticClass: "pl-10 pr-10 bg-white" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                ref: "table_box",
                attrs: {
                  id: "table_box",
                  data: _vm.list,
                  "element-loading-text": "Loading",
                  stripe: "",
                  "highlight-current-row": "",
                  "max-height": _vm.tableMaxH,
                },
                on: { "selection-change": _vm.selSb },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "50" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "编号", width: "150" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.code_sn) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  attrs: { label: "秘钥", width: "150" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.secret_key) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  attrs: { label: "厂家", width: "150" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.factory_name) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "设备号" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.device_id || "--") +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "类型" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.deviceList[scope.row.code_tag]
                                  ? _vm.deviceList[scope.row.code_tag].type_name
                                  : _vm.showCodeType(
                                      scope.row.code_tag,
                                      scope.row.code_sn
                                    )
                              ) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "代理" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.agent_name[scope.row.agent_id] || "--"
                              ) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "二维码内容" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.code_body || "--") +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "状态", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.status == 1 ? "已分配" : "未分配"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "生成时间", width: "160" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.parseTime(
                                  scope.row.created,
                                  "{y}-{m}-{d} {h}:{i}"
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "更新时间", width: "160" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.parseTime(
                                  scope.row.updated,
                                  "{y}-{m}-{d} {h}:{i}"
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "下载", width: "80" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.code_url
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content:
                                      '全选后点击查询后的"下载"按钮可下载本页所有设备二维码图片',
                                    placement: "top",
                                  },
                                },
                                [
                                  _c(
                                    "el-link",
                                    {
                                      attrs: {
                                        href: scope.row.code_url,
                                        target: "_blank",
                                        type: "primary",
                                      },
                                    },
                                    [_vm._v("下载")]
                                  ),
                                ],
                                1
                              )
                            : scope.row.code_body && !scope.row.code_url
                            ? _c(
                                "a",
                                {
                                  staticClass: "text-blue",
                                  on: {
                                    click: function ($event) {
                                      return _vm.createImg(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("生成图片")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                round: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.editCode(scope.row)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                round: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setEquip(scope.row)
                                },
                              },
                            },
                            [_vm._v("分配设备")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex justify-center" },
              [
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.listQuery.page_num > 0,
                      expression: "listQuery.page_num > 0",
                    },
                  ],
                  attrs: {
                    page: _vm.listQuery.page,
                    "page-count": _vm.listQuery.page_num,
                    limit: _vm.listQuery.limit,
                    pageSizes: [20, 50, 100, 200, 500, 1000],
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.listQuery, "page", $event)
                    },
                    "update:limit": function ($event) {
                      return _vm.$set(_vm.listQuery, "limit", $event)
                    },
                    pagination: _vm.getList,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }